import { type ComponentProps, type ReactNode } from 'react';

import { Collapsible, CollapsibleContent } from '@/components/ui/collapsible';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

import { CollapsibleCell } from './collapsibleCell';

interface CollapsibleRowProps extends ComponentProps<'tbody'> {
  open: boolean;
  onToggle: () => void;
  /** Shown under the row once opened; left out, the row has no chevron. */
  expanded?: ReactNode;
  /** Every column of the table: `expanded` spans the full row. */
  colSpan: number;
  /** On the cell holding `expanded`. */
  expandedClassName?: string;
}

/**
 * A table row that opens on `expanded`. One tbody per row, so a virtualizer
 * measuring it (`ref`, `data-index` land on the tbody) spans the open row too.
 */
export const CollapsibleRow = ({
  open,
  onToggle,
  expanded,
  colSpan,
  expandedClassName,
  children,
  ...props
}: CollapsibleRowProps) => (
  <Collapsible open={open} onOpenChange={onToggle} asChild>
    <tbody {...props}>
      <TableRow>
        {expanded ? (
          <CollapsibleCell open={open} onOpenChange={onToggle} />
        ) : (
          <TableCell />
        )}
        {children}
      </TableRow>
      {expanded && (
        <CollapsibleContent asChild>
          <TableRow className="hover:bg-transparent">
            <TableCell
              colSpan={colSpan}
              className={cn('pt-0', expandedClassName)}
            >
              {expanded}
            </TableCell>
          </TableRow>
        </CollapsibleContent>
      )}
    </tbody>
  </Collapsible>
);
